:root{--col-width-benefit-options: calc(var(--col-width-plan) * 2 + 20px);--col-width-plan: 170px}.planBuilder_PlanBuilder_be9ea15{margin-bottom:15px}